import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-upload-large.tsx
/**
* icon.24.upload.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE5LjUgMTQuMDAxYS41LjUgMCAwIDEgLjUuNXYzLjVhMiAyIDAgMCAxLTIgMkg2YTIgMiAwIDAgMS0yLTJ2LTMuNWEuNS41IDAgMSAxIDEgMHYzLjVhMSAxIDAgMCAwIDEgMWgxMmExIDEgMCAwIDAgMS0xdi0zLjVhLjUuNSAwIDAgMSAuNS0uNU0xMS43MjUgMy4wODNhLjUuNSAwIDAgMSAuNjI5LjA2NGw0LjUgNC41YS41LjUgMCAwIDEtLjcwNy43MDdMMTIuNSA0LjcwOHY3Ljc5M2EuNS41IDAgMCAxLTEgMFY0LjcwOEw3Ljg1NCA4LjM1NGEuNS41IDAgMCAxLS43MDgtLjcwN2w0LjUtNC41eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58535
*/
const Icon24UploadLarge = memo(function Icon24UploadLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M19.5 14.001a.5.5 0 0 1 .5.5v3.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3.5a.5.5 0 1 1 1 0v3.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5a.5.5 0 0 1 .5-.5M11.725 3.083a.5.5 0 0 1 .629.064l4.5 4.5a.5.5 0 0 1-.707.707L12.5 4.708v7.793a.5.5 0 0 1-1 0V4.708L7.854 8.354a.5.5 0 0 1-.708-.707l4.5-4.5z"
		})
	});
});
//#endregion
export { Icon24UploadLarge };

//# sourceMappingURL=icon-24-upload-large.js.map